var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticStyle:{"min-height":"100vh"}},[_c('app-header'),_c('v-main',[_c('router-view'),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }